import { connect } from "react-redux";
import {
  getSpSettingFetchRequest,
  spRosteringSettingsRequest,
  spSettingUpdateRequest,
} from "../../../../store/actions/sp.actions";
import {
  getSpRosteringSetting,
  getSpSetting,
  getSpSettingLoader,
  getSpSettingUpdateLoader,
} from "../../../../store/selector/sp.selector";
import SpSetting from "./SpSetting";
import { getUser } from "store/selector/auth.selector";

const mapDispatchToProps = {
  getSpSettingRequest: getSpSettingFetchRequest,
  spSettingUpdateRequest,
  spRosteringSettingsRequest,
};

const mapStateToProps = (state) => {
  const isLoading = getSpSettingLoader(state);
  const settingUpdateLoading = getSpSettingUpdateLoader(state);
  const settings = getSpSetting(state);
  const loginUser=getUser(state)
  const spRosteringSetting = getSpRosteringSetting(state);
  return {
    isLoading,
    settings,
    settingUpdateLoading,
    loginUser,
    spRosteringSetting,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SpSetting);
